import { t } from "@lingui/macro";
import graphql from "babel-plugin-relay/macro";
import { useFragment } from "react-relay";

import { InfoBanner } from "@whoosh/design-system/src/components/display/InfoBanner/InfoBanner";
import {
  AlertIcon,
  InfoIcon,
} from "@whoosh/design-system/src/components/icons_v2/general";
import { Box } from "@whoosh/design-system/src/components/primitive";

import { EventDetailSeriesInfoBanner$key } from "./__generated__/EventDetailSeriesInfoBanner.graphql";

type EventDetailSeriesInfoBannerProps = {
  fragmentRef: EventDetailSeriesInfoBanner$key;
};

export const EventDetailSeriesInfoBanner = ({
  fragmentRef,
}: EventDetailSeriesInfoBannerProps) => {
  const data = useFragment(EventDetailSeriesInfoBannerFragment, fragmentRef);
  const { limitSeriesSignUps, accessStatusForClient, signUpStatusForClient } =
    data;

  const memberAlreadyInCurrentEvent = signUpStatusForClient === "CONFIRMED";
  const showWarningBanner = accessStatusForClient !== "ALREADY_IN_SERIES";

  const bannerText = showWarningBanner
    ? t`You will not be able to sign up for more than one event in this series.`
    : t`You have already signed up for an event in this series.`;

  const BannerIcon = showWarningBanner ? InfoIcon : AlertIcon;

  return limitSeriesSignUps && !memberAlreadyInCurrentEvent ? (
    <Box mt={4} mb={2}>
      <InfoBanner
        message={bannerText}
        leadingIcon={BannerIcon}
        colorTheme={showWarningBanner ? "WARNING" : "ERROR"}
      />
    </Box>
  ) : null;
};

export const EventDetailSeriesInfoBannerFragment = graphql`
  fragment EventDetailSeriesInfoBanner on Event {
    limitSeriesSignUps
    accessStatusForClient(clientId: $memberId)
    signUpStatusForClient(clientId: $memberId)
  }
`;
